<template>
    <v-dialog v-model="dialog" persistent content-class="modal-dialog">
        <v-card class="modal-adaptive">
            <div class="common-text text-center mb-2">
                Заселение гостей
            </div>
            <div class="main-text mb-2">
                Дата и время заселения
            </div>
            <v-flex class="modal-row d-flex justify-space-between mb-3">
                <v-menu
                    v-model="dateInMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    content-class="v-menu-picker"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="dateFormattedIn"
                            placeholder="__.__.____"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            class="input-picker-grey mr-2"
                            dense
                            hide-details
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="dateIn"
                        no-title
                        locale="ru-ru"
                        @input="dateInMenu = false"
                        color="#FFD3BC"
                        :max="dateOut"
                    ></v-date-picker>
                </v-menu>
                <v-text-field
                    v-model="timeIn"
                    placeholder="Время"
                    type="time"
                    class="input-picker-grey ml-2"
                    dense
                    hide-details
                ></v-text-field>
            </v-flex>
            <div class="main-text mb-2">
                Дата и время выселения
            </div>
            <v-flex class="modal-row d-flex justify-space-between mb-6">
                <v-menu
                    v-model="dateOutMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    content-class="v-menu-picker"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="dateFormattedOut"
                            placeholder="__.__.____"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            class="input-picker-grey mr-2"
                            dense
                            hide-details
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="dateOut"
                        no-title
                        locale="ru-ru"
                        @input="dateOutMenu = false"
                        color="#FFD3BC"
                        :min="dateIn"
                    ></v-date-picker>
                </v-menu>
                <v-text-field
                    v-model="timeOut"
                    placeholder="Время"
                    type="time"
                    class="input-picker-grey ml-2"
                    dense
                    hide-details
                ></v-text-field>
            </v-flex>
            <v-flex class="modal-row d-flex justify-end">
                <v-btn class="btn-grey main-text" @click="cancel">
                    Отмена
                </v-btn>
                <v-btn class="btn-gradient main-text" @click="addGuest" :disabled="!disabled">
                    Выдать доступ
                </v-btn>
            </v-flex>
            <v-flex v-if="edit && !edit.update">
                <v-divider class="my-3"></v-divider>
                <v-btn class="main-text btn-grey full-width-btn" @click.stop.prevent="openModalDeleteGuest">
                    Выселить
                </v-btn>
            </v-flex>
        </v-card>
        <ModalWaiting ref="modalWaiting" title="Заселение гостей" text="QR-код формируется..."></ModalWaiting>
        <ModalQRCode v-model="modalQRCode" :qrlink="qrlink" :name="name"></ModalQRCode>
        <ModalDeleteConfirm
            v-model="modalDeleteGuest"
            :close="closeModalDeleteGuest"
            :url="`/hotels/hotel-admin/master-key-for-room/${edit.uid}/`"
            submit-title="Выселить"
            v-if="edit"
            :update="cancel"
        >
            <template #deleteTitle>
                Вы действительно хотите <br> выселить гостей до окончания <br> срока их пребывания?
            </template>
            <template #deleteSubtitle>
                После выселения у гостей пропадёт <br> доступ к управлению устройствами
            </template>
        </ModalDeleteConfirm>
        <ModalWaiting
            ref="modalError"
            title="Ошибка заселения"
            :text="errorModalMessage"
            text-btn="OК"
            no-loading
            text-center
        ></ModalWaiting>
    </v-dialog>
</template>

<script>
import { timeToUTC, timeWithTZ } from '@/utils/index';
import ModalWaiting from "@/components/modals/ModalWaiting";
import ModalQRCode from "@/components/modals/ModalQRCode";
import ModalDeleteConfirm from "@/components/modals/ModalDeleteConfirm";

export default {
    name: "ModalAddGuest",
    components: {ModalWaiting, ModalQRCode, ModalDeleteConfirm},
    props: {
        value: {
            type: Boolean,
        },
        room: {
            type: String,
        },
        name: {
            type: String,
        },
        close: {
            type: Function,
            default: () => {},
        },
        edit: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            dialog: false,
            dateIn: null,
            dateFormattedIn: null,
            timeIn: "14:00",
            dateInMenu: false,
            dateOut: null,
            dateOutMenu: false,
            dateFormattedOut: null,
            timeOut: "12:00",
            qrlink: null,
            modalQRCode: false,
            modalDeleteGuest: false,
            errorModalMessage: "",
        }
    },
    created() {
        this.dateIn = new Date().toISOString().slice(0, 10);
    },
    computed: {
        disabled() {
            return this.dateIn && this.timeIn && this.dateOut && this.timeOut;
        },
    },
    watch: {
        value(val) {
            if (val != this.dialog) {
                this.dialog = val;
                if (this.edit) {
                    if (this.edit.valid_after) {
                        let validAfter = timeWithTZ(this.edit.valid_after).split('T');
                        this.dateIn = validAfter[0];
                        this.timeIn = this.edit.update ? this.timeIn : validAfter[1].slice(0, 5);
                    }
                    if (this.edit.valid_until) {
                        let validUntil = timeWithTZ(this.edit.valid_until).split('T');
                        this.dateOut = validUntil[0];
                        this.timeOut = validUntil[1] ? validUntil[1].slice(0, 5) : this.timeOut;
                    }
                }
            }
        },
        dateIn(val) {
            this.dateFormattedIn = this.formatDate(val);
        },
        dateOut(val) {
            this.dateFormattedOut = this.formatDate(val);
        },
    },
    methods: {
        open() {
            this.dialog = true;
        },
        cancel() {
            this.dateIn = new Date().toISOString().slice(0, 10);
            this.dateOut = null;
            this.timeIn = "14:00";
            this.timeOut = "12:00";
            this.dialog = false;
            if (this.close) {
                this.close();
            }
            this.$emit('input', false);
        },
        formatDate(date) {
            if (!date) return null;
            let [year, month, day] = date.split('-');
            return `${day}.${month}.${year}`;
        },
        addGuest() {
            let valid_after = this.getRequestDate(this.dateIn, this.timeIn);
            let valid_until = this.getRequestDate(this.dateOut, this.timeOut);
            valid_after = timeToUTC(valid_after);
            valid_until = timeToUTC(valid_until);
            this.$refs.modalWaiting.open();
            this.dialog = false;
            let method = "post";
            let url = "/hotels/hotel-admin/master-key-for-room/";
            let params = {
                valid_after: valid_after,
                valid_until: valid_until,
            }
            if (this.edit && this.edit.uid) {
                method = "put";
                url = `/hotels/hotel-admin/master-key-for-room/${this.edit.uid}/`
            } else {
                params.room = this.room;
            }
            this.$http[method](url, params)
                .then((response) => {
                    this.$refs.modalWaiting.close();
                    this.qrlink = response.data.key;
                    if (this.qrlink) {
                        this.modalQRCode = true;
                    }
                    if (this.edit) {
                        this.$emit("updateRoom", response.data);
                    }
                    this.cancel();
                })
                .catch((error) => {
                    console.log(error);
                    this.$refs.modalWaiting.close();
                    this.dialog = true;
                    this.errorModalMessage = "";
                    if (error.response) {
                        error.response.data.forEach((err, index) => {
                            this.errorModalMessage += err.message;
                            if (index > 0) {
                                this.errorModalMessage += "<br>";
                            }
                        });
                    }
                    this.$refs.modalError.open();
                });
        },
        openModalDeleteGuest() {
            this.modalDeleteGuest = true;
        },
        closeModalDeleteGuest() {
            this.modalDeleteGuest = false;
        },
        getRequestDate(date, time) {
            if (!date) return null;
            if (!time) return null;
            return `${date}T${time}:00.000Z`;
        },
    }

}
</script>

<style lang="scss" scoped>
.btn-grey.v-btn {
    max-width: 94px;
    text-transform: none;
    margin-right: 10px;
}

.btn-gradient.v-btn {
    max-width: 165px;
}
</style>